import React from "react";
import type { PopupRuntimeContext } from "./types";
import { FormBuilder } from "../components/FormBuilder";

// Renderiza no popup um formulário SALVO (escolhido por id no builder), reusando o
// FormBuilder do bloco 2.0. A atribuição do lead ao popup viaja como:
//   product = "popup", productName = título do popup, popupId (customParameters).
// O FormBuilder já injeta origin_url, antibot, campanha e submete ao crm-api.

interface PopupFormProps {
  form?: unknown;
  teamId?: string;
  ctx: PopupRuntimeContext;
  popupId: string;
  popupName: string;
  onConverted: () => void;
}

export const PopupForm = ({ form, teamId, ctx, popupId, popupName, onConverted }: PopupFormProps) => {
  if (!form) {
    return (
      <div style={{ padding: 16, textAlign: "center", fontSize: 14, color: "#6B7280" }}>
        Formulário indisponível.
      </div>
    );
  }

  return (
    <FormBuilder
      form={form}
      antiBot={ctx.antiBot ?? null}
      product="popup"
      channel={ctx.channelName || "Popup"}
      siteId={ctx.siteId ?? undefined}
      accountId={ctx.accountId ?? undefined}
      teamId={teamId}
      formId={(form as { id?: string }).id}
      // Título do popup + id vão em customParameters (productName e popupId — este
      // último é o que a área de Leads filtra por popup).
      dynamicFields={[
        { id: "productName", key: "productName", value: popupName },
        { id: "popupId", key: "popupId", value: popupId },
      ]}
      onSubmitSuccess={() => onConverted()}
    />
  );
};
